var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import React, { Component } from 'react';
import { Pagination } from 'react-bootstrap';
var TutorialPaginationList = function (_a) {
  var pageCount = _a.pageCount,
    currentPage = _a.currentPage,
    onPageChanged = _a.onPageChanged;
  var paginationItems = Array.from(Array(pageCount).keys()).map(function (el, index) {
    var onClick = function () {
      onPageChanged(index);
    };
    return React.createElement(Pagination.Item, {
      key: index,
      className: 'rounded mx-1',
      active: index === Math.round(currentPage),
      onClick: onClick
    }, el + 1);
  });
  return React.createElement(React.Fragment, null, paginationItems);
};
var HOPagination = /** @class */function (_super) {
  __extends(HOPagination, _super);
  function HOPagination() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onPageChanged = function (currentPage) {
      _this.props.onPageChanged(currentPage);
      window.scrollTo(0, 0);
    };
    _this.onPrevClick = function () {
      _this.props.onPageChanged(_this.props.currentPage - 1);
      window.scrollTo(0, 0);
    };
    _this.onNextClick = function () {
      _this.props.onPageChanged(_this.props.currentPage + 1);
      window.scrollTo(0, 0);
    };
    return _this;
  }
  HOPagination.prototype.render = function () {
    var _a = this.props,
      countTutorials = _a.countTutorials,
      itemsPerPage = _a.itemsPerPage,
      currentPage = _a.currentPage;
    var pageCount = Math.ceil(countTutorials / itemsPerPage);
    return React.createElement("div", {
      className: 'd-flex justify-content-center mt-4'
    }, React.createElement(Pagination, {
      className: 'font-weight-bold'
    }, currentPage !== 0 && React.createElement(Pagination.Prev, {
      className: 'rounded',
      onClick: this.onPrevClick
    }, React.createElement("i", {
      className: 'fa fa-chevron-left'
    })), React.createElement(TutorialPaginationList, {
      pageCount: pageCount,
      currentPage: currentPage,
      onPageChanged: this.onPageChanged
    }), currentPage !== pageCount - 1 && React.createElement(Pagination.Next, {
      className: 'rounded',
      onClick: this.onNextClick
    }, React.createElement("i", {
      className: 'fa fa-chevron-right'
    }))));
  };
  return HOPagination;
}(Component);
export { HOPagination };